@if (nickname()) {
  <h1>DJ: {{ nickname() }}</h1>

}

<p-button label="TV" [raised]="true" severity="secondary" routerLink="/tv" />

@if (nickname()) {
  <p-button
    label="Playlist"
    [raised]="true"
    severity="secondary"
    routerLink="/jam" />
} @else {
  <p-button
    label="Playlist"
    [raised]="true"
    severity="secondary"
    routerLink="/register" />
}

<section>
  @if (socket.connected()) {
    {{ socket.message() }}
  }
</section>
